import gql from "graphql-tag";

const GET_ALL_PAGES_QUERY = gql`
  query getAllPages {
    pages(sort: "created_at:desc") {
      slug
      kicker
      title
      summary
      created_at
      updated_at
      published_at
      splash {
        alternativeText
        caption
        formats
      }
      metaData {
        showTOC
        showInNav
        showInFooter
        showLastUpdated
        showInSidebar
        menuTitle
        menuRank
        showBanner
        isGated
      }
    }
  }
`;

const GET_SINGLE_PAGE_QUERY = gql`
  query getSinglePage($slug: String!) {
    pages(where: { slug: $slug }) {
      slug
      title
      summary
      kicker
      created_at
      updated_at
      published_at
      body

      metaData {
        showTOC
        showInNav
        showInFooter
        showLastUpdated
        showInSidebar
        menuTitle
        menuRank
        showBanner
        isGated
      }
      splash {
        alternativeText
        caption
        formats
      }
    }
  }
`;

export { GET_ALL_PAGES_QUERY, GET_SINGLE_PAGE_QUERY };
